import { useEffect, useState } from "react";
import { getMyLeadsApi, getLeadsByUserIdApi, syncLeadsNowApi, getLeadDetailsApi, updateLeadStageApi, updateLeadRemarkApi, createLeadViewHistoryApi, getLeadActivityApi, createLeadActivityLogApi, getNewLeadsApi } from "../apiServices/leadServices";

const useLeads = (params = {}) => {
  const [activities,setActivities]=useState([]);
  const [activityLoading,setActivityLoading]=useState(false);
  const [activityPagination,setActivityPagination]=useState({});
  const [leads, setLeads] = useState([]);
  const [syncLoading,setSyncLoading]=useState(false);
  const [leadDetails, setLeadDetails] = useState(null);
  const [userName,setUserName]=useState("");
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ page: 1, totalPages: 1, total: 0, });
  const setPaginationData = (data) => { setPagination({ page: data?.page || 1, totalPages: data?.totalPages || 1, total: data?.total || 0, }); };

  const syncLeadsNow=async()=>{
    try{
      setSyncLoading(true);
      const response=await syncLeadsNowApi();
      return response;
    }catch(error){
      console.error(error);
      throw error;
    }finally{
      setSyncLoading(false);
    }
  };


  const fetchMyLeads = async (queryParams = params) => {
    try {
      setLoading(true);
      const data = await getMyLeadsApi(queryParams);
      setLeads(data?.data?.leads || []);
      setPaginationData(data?.data || {});
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchNewLeads = async (queryParams = params) => {
    try {
      setLoading(true);
      const data = await getNewLeadsApi(queryParams);
      setLeads(data?.data?.leads || []);
      setPaginationData(data?.data || {});
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchLeadsByUserId = async (userId, query = "") => {
    try {
      setLoading(true);
      const response = await getLeadsByUserIdApi(userId, query);
      const data = response?.data || {};
      setLeads(data?.leads || []);
      setUserName(data?.userName || "");
      setPagination({
        page: data?.page || 1,
        total: data?.total || 0,
        totalPages: data?.totalPages || 1,
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchLeadDetails = async (source,leadId) => {
    try {
      setLoading(true);
      const response = await getLeadDetailsApi(source,leadId);
      const data = response?.data?.data || {};
      setLeadDetails(data);
      return data;
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const updateLeadStage = async (source,leadId, stageId) => {
    try {
      await updateLeadStageApi(source,leadId, { stageId });
      await fetchMyLeads();
      if (leadDetails?._id === leadId) { await fetchLeadDetails(source, leadId); }
    } catch (error) {
      console.error(error);
    }
  };

  const updateLeadRemark = async (source, leadId, remark) => {
    try {
      await updateLeadRemarkApi(source, leadId, { remark });
      if (leadDetails?._id === leadId) { await fetchLeadDetails(source, leadId); }
    } catch (error) {
      console.error(error);
    }
  };

  const createLeadViewHistory = async (source,leadId) => {
    try {
      await createLeadViewHistoryApi(source,leadId);
    } catch (error) {
      console.error(error);
    }
  };
  const fetchLeadActivity=async( source,leadId, params={} )=>{
    try{
      setActivityLoading(true);
      const res= await getLeadActivityApi( source,leadId, params );
      setActivities( res?.data?.data?.records || [] );
      setActivityPagination( res?.data?.data?.pagination || {} );
    }catch(error){
      console.error(error);
    }finally{
      setActivityLoading(false);
    }
  };
  const createLeadActivityLog=async(source,leadId,data)=>{
    try{
      await createLeadActivityLogApi( source, leadId, data );
    }catch(error){
      console.error(error);
    }
  };
  useEffect(() => {
    if (Object.keys(params || {}).length > 0) {
      fetchMyLeads();
    }
  }, [JSON.stringify(params)]);
  return { leads, leadDetails, loading,activityLoading, userName, pagination,activities,activityPagination, fetchMyLeads, fetchNewLeads, fetchLeadsByUserId, fetchLeadDetails,createLeadActivityLog, updateLeadStage, updateLeadRemark, createLeadViewHistory,  fetchLeadActivity };
};

export default useLeads;